import { render, staticRenderFns } from "./StatementContractDetail.vue?vue&type=template&id=0e8142ba&scoped=true"
import script from "./StatementContractDetail.vue?vue&type=script&lang=js"
export * from "./StatementContractDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8142ba",
  null
  
)

export default component.exports